import React from "react";
import PropTypes from "prop-types";
import FudesciLogo from "../../assets/img/common/fundesci.png";
import { Helmet } from "react-helmet-async";
const DOMAIN = "https://fundesci.com";

// const DEFAULT_IMAGE_CARD =
//   "https://api.fundesci.com/uploads/images/LVrJ6b593_img.jpeg";
const DEFAULT_IMAGE_CARD = FudesciLogo;
const DEFAULT_TITLE = "FunDeSci, NFT-Fundraising platform";
const DEFAULT_DESCRIPTION =
  "NFT- Fundraising By FunDeSci An innovative approach for decentralized crowdfunding of scientific projects";

const FAVICON_SOURCE = "https://fundesci.com/favicon.ico";

const POSTFIX_TITLE = " | FunDeSci";

function MetaTags({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  link = "",
  imageCard = DEFAULT_IMAGE_CARD,
  largeTwitterCard = false,
  addPostfixTitle = true,
  noIndex = false,
  children = null,
}) {
  let metaTitle;

  if (addPostfixTitle) {
    metaTitle = title + POSTFIX_TITLE;
  } else {
    metaTitle = title;
  }

  const metaDesc = description?.length ? description : DEFAULT_DESCRIPTION;
  const metaLink = DOMAIN + link;

  let metaImageCard;

  if (imageCard) {
    if (imageCard.startsWith("https")) {
      metaImageCard = imageCard;
    } else {
      metaImageCard = DOMAIN + imageCard;
    }
  } else {
    metaImageCard = DEFAULT_IMAGE_CARD;
  }

  const metaRobots = noIndex ? "noindex, nofollow" : "index, follow";

  const twitterCardType = largeTwitterCard ? "summary_large_image" : "summary";

  return (
    <Helmet>
      <html lang="en" />
      <title>{metaTitle}</title>
      <meta name="description" content={metaDesc} />
      <link rel="canonical" href={metaLink} />
      <meta name="robots" content={metaRobots} />
      <link rel="icon" href={FAVICON_SOURCE} />

      {/* OG Tags */}
      {/* https://ogp.me/ */}
      <meta property="og:url" title={metaLink} content={metaLink} />
      <meta property="og:title" title={metaTitle} content={metaTitle} />
      <meta property="og:description" title={metaDesc} content={metaDesc} />
      <meta property="og:type" content="..." />
      <meta property="og:image" content={metaImageCard} />

      {/* Twitter tags */}
      {/* https://developer.twitter.com/en/docs/twitter-for-websites/cards/guides/getting-started */}
      <meta property="twitter:site" title="twitter username of website" />
      <meta property="twitter:title" title={metaTitle} />
      <meta property="twitter:description" title={metaDesc} />
      <meta
        property="twitter:creator"
        content="twitter username of webpage content"
      />
      <meta property="twitter:card" content={twitterCardType} />
      <meta property="twitter:image" content={metaImageCard} />

      <meta name="referrer" content="origin-when-crossorigin" />

      {children}
    </Helmet>
  );
}

MetaTags.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
  imageCard: PropTypes.string,
  largeTwitterCard: PropTypes.bool,
  addPostfixTitle: PropTypes.bool,
  noIndex: PropTypes.bool,
  children: PropTypes.node,
};

export default MetaTags;
